<template>
    <div class="music-box cursor-pointer" @click="toggleMusic">
        <i v-if="!isPlaying" class="theme-ui-text-color far fa-play-circle"></i>
        <i v-if="isPlaying" class="theme-ui-text-color far fa-pause-circle"></i>
        <div class="equalizer">
            <span class="sub"></span>
            <span class="sub"></span>
            <span class="sub"></span>
            <span class="sub"></span>
            <span class="sub"></span>
            <span class="sub"></span>
        </div>
    </div>
</template>

<script>
import gsap from 'gsap'

export default {
    name: 'live-quiz-equalizer',

    data() {
        return {
            isPlaying: false
        }
    },

    mounted() {
        gsap.set('.music-box > .equalizer', { opacity: 0 })
    },

    methods: {
        showPlayer() {
            this.isPlaying = true
            let span = document.querySelectorAll('.equalizer > .sub')
            gsap.to('.music-box', { duration: 0.5, width: '115px', ease: 'power4.out' })
            gsap.to('.music-box > .equalizer', { duration: 0.3, opacity: 1 })
            span.forEach(span => {
                span.classList.add('active')
            })
        },

        hidePlayer() {
            this.isPlaying = false
            let span = document.querySelectorAll('.equalizer > .sub')
            gsap.to('.music-box', { duration: 0.5, width: '42px', ease: 'power4.out' })
            gsap.to('.music-box > .equalizer', { duration: 0.1, opacity: 0 })
            span.forEach(span => {
                span.classList.remove('active')
            })
        },

        toggleMusic() {
            this.isPlaying = !this.isPlaying
            if (this.isPlaying) {
                this.showPlayer()
            } else {
                this.hidePlayer()
            }
            this.$emit('click')
        }
    }
}
</script>

<style lang="scss" scoped>
.music-box {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 42px;
    height: 42px;
    background-color: #000;
    border-radius: 50px;
    padding: 5px;
    margin-top: 0.5rem;

    i {
        color: #fff;
        font-size: 2rem;
    }

    .equalizer {
        display: flex;
        margin-right: 5px;
        padding: 0 0 0 0;
        position: relative;
        width: 60px;
        height: 30px;

        span {
            position: absolute;
            bottom: 0;
            display: inline-block;
            width: calc((100% / 6) - 3px);
            height: 20%;
            background-color: var(--ui-color);
            box-shadow: 1px 1px 5px rgba(0, 0, 0, 0.5);

            &:nth-child(1) {
                left: 0;

                &.active {
                    animation: equaliser 2.5s 0.1s ease-out alternate infinite;
                }
            }

            &:nth-child(2) {
                left: 16%;

                &.active {
                    animation: equaliser 2.5s 0.05s ease-out alternate infinite;
                }
            }

            &:nth-child(3) {
                left: 32%;

                &.active {
                    animation: equaliser 2.5s 0s ease-out alternate infinite;
                }
            }

            &:nth-child(4) {
                left: 48%;

                &.active {
                    animation: equaliser 2.5s 0.25s ease-out alternate infinite;
                }
            }

            &:nth-child(5) {
                left: 64%;

                &.active {
                    animation: equaliser 2.5s 0.2s ease-out alternate infinite;
                }
            }

            &:nth-child(6) {
                left: 80%;

                &.active {
                    animation: equaliser 2.5s 0.4s ease-out alternate infinite;
                }
            }

            @keyframes equaliser {
                0% {
                    height: 20%;
                }
                20% {
                    height: 50%;
                }
                30% {
                    height: 30%;
                }
                50% {
                    height: 70%;
                }
                60% {
                    height: 40%;
                }
                70% {
                    height: 70%;
                }
                80% {
                    height: 60%;
                }
                100% {
                    height: 20%;
                }
            }
        }
    }
}
</style>
